import {app_id} from '@/plugins/projectvars.js'; 

var customerchat = "<script>"+
'\n'+"window.fbAsyncInit = function() {"+
'\n'+"  FB.init({"+
'\n'+"  appId            : "+app_id+","+
'\n'+"  autoLogAppEvents : true,"+
'\n'+"  xfbml            : true,"+
'\n'+"  version          : 'v3.2'"+
'\n'+"  });"+
'\n'+"};"+
'\n'+
'\n'+"(function(d, s, id){"+
'\n'+" var js, fjs = d.getElementsByTagName(s)[0];"+
'\n'+" if (d.getElementById(id)) {return;}"+
'\n'+" js = d.createElement(s); js.id = id;"+
'\n'+" js.src = \"https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js\";"+
'\n'+" fjs.parentNode.insertBefore(js, fjs);"+
'\n'+"}(document, 'script', 'facebook-jssdk'));"+
'\n'+"<\/script>";

var messageus = "<script>"+
'\n'+"window.fbAsyncInit = function() {"+
'\n'+"  FB.init({"+
'\n'+"  appId            : "+app_id+","+
'\n'+"  autoLogAppEvents : true,"+
'\n'+"  xfbml            : true,"+
'\n'+"  version          : 'v3.2'"+
'\n'+"  });"+
'\n'+"};"+
'\n'+
'\n'+"(function(d, s, id){"+
'\n'+" var js, fjs = d.getElementsByTagName(s)[0];"+
'\n'+" if (d.getElementById(id)) {return;}"+
'\n'+" js = d.createElement(s); js.id = id;"+
'\n'+" js.src = \"https://connect.facebook.net/en_US/sdk.js\";"+
'\n'+" fjs.parentNode.insertBefore(js, fjs);"+
'\n'+"}(document, 'script', 'facebook-jssdk'));"+
'\n'+"<\/script>";

var sendtomessenger = "<script>"+
'\n'+"window.fbAsyncInit = function() {"+
'\n'+"  FB.init({"+
'\n'+"  appId            : "+app_id+","+
'\n'+"  autoLogAppEvents : true,"+
'\n'+"  xfbml            : true,"+
'\n'+"  version          : 'v3.2'"+
'\n'+"  });"+
'\n'+"FB.Event.subscribe('send_to_messenger', function(e) {"+
'\n'+"});"+
'\n'+"};"+
'\n'+
'\n'+"(function(d, s, id){"+
'\n'+" var js, fjs = d.getElementsByTagName(s)[0];"+
'\n'+" if (d.getElementById(id)) {return;}"+
'\n'+" js = d.createElement(s); js.id = id;"+
'\n'+" js.src = \"https://connect.facebook.net/en_US/sdk.js\";"+
'\n'+" fjs.parentNode.insertBefore(js, fjs);"+
'\n'+"}(document, 'script', 'facebook-jssdk'));"+
'\n'+"<\/script>";

var checkbox = "<script>"+
'\n'+"window.fbAsyncInit = function() {"+
'\n'+"  FB.init({"+
'\n'+"  appId            : "+app_id+","+
'\n'+"  autoLogAppEvents : true,"+
'\n'+"  xfbml            : true,"+
'\n'+"  version          : 'v3.2'"+
'\n'+"  });"+
'\n'+"FB.Event.subscribe('messenger_checkbox', function(e) {"+
'\n'+"});"+
'\n'+"};"+
'\n'+
'\n'+"(function(d, s, id){"+
'\n'+" var js, fjs = d.getElementsByTagName(s)[0];"+
'\n'+" if (d.getElementById(id)) {return;}"+
'\n'+" js = d.createElement(s); js.id = id;"+
'\n'+" js.src = \"https://connect.facebook.net/en_US/sdk.js\";"+
'\n'+" fjs.parentNode.insertBefore(js, fjs);"+
'\n'+"}(document, 'script', 'facebook-jssdk'));"+
'\n'+"<\/script>"+
'\n'+"<script src=\"http://wzrd.in/standalone/uuid%2Fv1@latest\">"+
'\n'+"		document.getElementsByClassName(\"fb-messenger-checkbox\").user_ref = uuidv1();"+
'\n'+"	<\/script>"

export {
    customerchat,
    messageus,
    sendtomessenger,
    checkbox
}